import React, { ReactNode, CSSProperties, UIEvent } from 'react';
import { m } from 'framer-motion';

export interface IFadeTransition {
    className: string;
    style: CSSProperties;
    children?: ReactNode;
    onClick?: (event: UIEvent) => void;
}

const TRANSITION = { ease: 'easeIn', duration: 0.2 };
const MINOPACITY = { opacity: 0, transition: TRANSITION };
const MAXOPACITY = { opacity: 1, transition: TRANSITION };

function FadeTransition(props: IFadeTransition): JSX.Element {
    return (
        <m.div
            className={props.className}
            style={props.style}
            onClick={props.onClick}
            initial={MINOPACITY}
            animate={MAXOPACITY}
            exit={MINOPACITY}
        >
            {props.children}
        </m.div>
    );
}

export default FadeTransition;
